import request from '@/utils/request';
//微信公众号appid列表
export function getAppIdList() {
  return request('/wechat/queryWechatAccountList', {
    method: 'GET',
    // data: values,
  });
}
//微信小程序appid列表
export function getWmpAccountList() {
  return request('/wechat/queryWechatMiniProgramAccountList', {
    method: 'GET',
    // data: values,
  });
}
//公众号模板列表
export function getWechatTemplateList(values) {
  return request('/wechat/queryTempPage', {
    method: 'POST',
    data: values,
  });
}
//小程序模板列表
export function getWmpTemplateList(values) {
  return request('/wechat/queryWmpTempPage', {
    method: 'POST',
    data: values,
  });
}
//公众号模板消息列表
export function getWechatTemplateMessageList(values) {
  return request('/wechat/queryTempMsgPage', {
    method: 'POST',
    data: values,
  });
}
//小程序模板消息列表
export function getWmpTemplateMessageList(values) {
  return request('/wechat/queryWmpTempMsgPage', {
    method: 'POST',
    data: values,
  });
}
//删除模板消息
export function deleteTemplateMessage(values) {
  return request('/wechat/deleteTempMsg', {
    method: 'POST',
    data: values,
  });
}
//删除小程序模板消息
export function deleteWmpTemplateMessage(values) {
  return request('/wechat/deleteWmpTempMsg', {
    method: 'POST',
    data: values,
  });
}
//同步微信模板
export function syncTemplate(values) {
  return request('/wechat/syncTemp', {
    method: 'POST',
    data: values,
  });
}
//同步小程序微信模板
export function syncWmpTemplate(values) {
  return request('/wechat/syncWmpTemp', {
    method: 'POST',
    data: values,
  });
}
